import * as actionTypes from "./ActionTypes";
import Axios from "../../axios-instance";
// FECTH GRADE LIST

export const saveGrades = (grades) => {
  return {
    type: actionTypes.GET_GRADE_LIST,
    gradeList: grades,
  };
};

export const fetchGradeList = () => {
  return (dispatch) => {
    Axios.get("/get/vk/classes").then((response) => {
      dispatch(saveGrades(response.data));
    });
  };
};

// FETCH SUBJECT LIST

export const saveSubjects = (subjects) => {
  return {
    type: actionTypes.GET_SUBJECTS_LIST,
    subjectList: subjects,
  };
};

export const fetchSubjectsList = () => {
  return (dispatch) => {
    Axios.get("/get/vk/subjects").then((response) => {
      dispatch(saveSubjects(response.data));
    });
  };
};

// FETCH BOARD LIST

export const saveBoard = (boards) => {
  return {
    type: actionTypes.GET_BOARD_LIST,
    boardList: boards,
  };
};

export const fetchBoardList = () => {
  return (dispatch) => {
    Axios.get("/get/vk/boards").then((response) => {
      dispatch(saveBoard(response.data));
    });
  };
};

export const initPagination = () => {
  return {
    type: actionTypes.INIT_PAGINATION,
  };
};

export const paginatedBooks = (response) => {
  return {
    type: actionTypes.PAGINATED_BOOKS,
    books: response,
  };
};

export const getPaginatedBooks = (payload,page,bookType) => {
  return (dispatch) => {
    dispatch(initPagination());
   if(bookType === 'allBooks'){
    Axios.post(`/get/vk/books/filtered?page=${page}`,payload).then((response) => {
      dispatch(paginatedBooks(response.data.data));
    });
   }
   else{
    Axios.get(`get/google/play/store/books?page=${page}`,payload).then((response) => {
      dispatch(paginatedBooks(response.data.data));
    });
   }
  };
};

export const savePayload = (sentPayload) => {
  return {
    type: actionTypes.SAVE_PAYLOAD,
    payload:sentPayload
  };
};
